export function parseReportRecipients(value: string) {
  return [
    ...new Set(
      value
        .split(/[\n,]/)
        .map((recipient) => recipient.trim())
        .filter(Boolean),
    ),
  ];
}
